<div
  class="line-item-inner relative flex flex-wrap justify-between gap-5 p-5 font-lato text-sm font-normal text-[#0f2744] max-[426px]:px-5 max-[426px]:py-4"
>
  <div
    class="line-item-description flex w-full flex-col gap-4 xl:flex-row xl:items-start xl:justify-between"
  >
    <div
      class="grid w-full grid-cols-1 gap-x-4 gap-y-2 xl:flex-1 xl:grid-cols-[70%_30%]"
    >
      <div class="flex items-center gap-1 uppercase">
        Order Type:
        <span class="ml-1 font-bold text-gray-300">{{
          lineItem.RecordType.Name
        }}</span>
      </div>
      <div class="flex items-center gap-1 pl-4">
        <mat-icon
          class="max-h-5 min-w-5 max-w-5 text-center text-[1.12rem] leading-[1.25rem]"
        >
          account_tree
        </mat-icon>
        <span class="text-sm font-normal">
          {{ lineItem.Service__r?.Name || '' }}
        </span>
      </div>
      <div
        class="order-last flex items-center gap-1 pl-4 uppercase xl:order-none"
      >
        <mat-icon
          class="max-h-5 min-w-5 max-w-5 text-center text-[1.12rem] leading-[1.25rem]"
        >
          location_on
        </mat-icon>
        <span class="truncate text-sm font-normal xl:whitespace-nowrap">
          {{ lineItem.Location__r?.Name || '' }}
        </span>
      </div>
      <div class="flex items-center gap-1 pl-4">
        <mat-icon
          class="max-h-5 min-w-5 max-w-5 text-center text-[1.12rem] leading-[1.25rem]"
        >
          memory_alt
        </mat-icon>
        <span class="text-sm font-normal">
          {{ lineItem.Service_Type__c }}
        </span>
      </div>
    </div>

    <div
      class="w-52 min-w-[13rem] text-right !text-sm font-semibold uppercase tracking-wide max-[426px]:w-full max-[426px]:pl-8 max-[426px]:text-left"
    >
      <div
        class="status mb-2 flex items-center justify-end gap-2 max-[426px]:justify-start"
      >
        @if (
          lineItem.Service_Order2__c &&
          lineItem.Service_Order2__r?.Status__c !== 'Complete'
        ) {
          <span>STATUS:</span>
          <span
            class="label font-bold uppercase"
            [ngClass]="{
              'ml-1 text-[#2a4b98]':
                lineItem.Service_Order2__r?.Status__c === 'Ready' ||
                lineItem.Service_Order2__r?.Status__c === 'Pending',
              'ml-1 text-[#8793a2]':
                lineItem.Service_Order2__r?.Status__c === 'In Progress',
              'ml-2 text-[#ef4732]':
                lineItem.Service_Order2__r?.Status__c === 'Canceled',
            }"
          >
            @if (lineItem.Service_Order2__r?.Status__c === 'Ready') {
              <span>Pending</span>
            } @else {
              <span>{{ lineItem.Service_Order2__r?.Status__c ?? '' }} </span>
            }
          </span>
        }

        @if (
          lineItem.Service_Order2__c &&
          lineItem.Service_Order2__r?.Status__c === 'Complete'
        ) {
          <span class="mr-2 font-bold uppercase text-[#3dcc64]">
            Completed
          </span>
          <span>
            {{
              lineItem.Service_Order2__r?.Completed_Date__c | date: 'MM/dd/yy'
            }}
          </span>
        }

        <div
          class="view-more !h-5 !w-5 max-[426px]:absolute max-[426px]:right-5 max-[426px]:top-5"
        >
          <mat-icon class="!h-5 !w-5 text-[1.25rem] text-[#0D62FF]">
            arrow_forward_ios
          </mat-icon>
        </div>
      </div>

      @if (lineItem.Term__c) {
        <div class="line-item-term pr-7 text-sm font-normal">
          <span class="capitalize"> Term: </span>
          <span class="font-semibold">{{ lineItem.Term__c }} months</span>
        </div>
      }
    </div>
  </div>

  <a
    routerLink="{{ order.Id }}/line-items/{{ lineItem.Id }}"
    tabindex="-1"
    class="order-link-outer mobile absolute inset-0 z-10 hidden p-0 max-[767px]:block"
  >
    <div class="order-link mobile opacity-0">View Line Item</div>
  </a>
</div>
